import styled from "@emotion/styled";
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  Typography,
} from "@mui/material";
import { shouldForwardProp } from "../../common/Common.style";
import theme from "../../theme";

export const SettingsWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  overflow: auto;
  height: 100%;
`;

export const SettingsItem = styled(Box)`
  display: flex;
  align-items: center;
  padding: 0 16px;
  height: 56px;
  cursor: pointer;
  border: 1px solid ${theme.palette.grey[200]};
  border-radius: 4px;
  gap: 16px;

  &:hover {
    background: ${theme.message?.messageBackground};
  }
`;

export const SettingsItemsWrapper = styled(Box)`
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const SettingsItemLabel = styled(Typography)`
  font-size: 15px;
  font-weight: 500;
  color: ${theme.palette.grey[800]};
`;

type SelectProps = {
  fullWidth: boolean;
};

export const DesignationSelect = styled("select", {
  shouldForwardProp: prop =>
    shouldForwardProp<SelectProps>(["fullWidth"], prop),
})<SelectProps>(({ fullWidth }) => ({
  width: fullWidth ? "100%" : "40%",
  border: "none",
  height: "37px",
  borderBottom: "1px solid rgba(0, 0, 0, 0.42)",
  marginRight: "13px",
  fontSize: "16px",
  color: "rgb(0, 0, 0, 0.87)",
  outline: "none",
}));

export const DepartmentSelect = styled(Select, {
  shouldForwardProp: prop =>
    shouldForwardProp<SelectProps>(["fullWidth"], prop),
})<SelectProps>(({ fullWidth }) => ({
  width: fullWidth ? "100%" : "40%",
  border: "none",
  height: "37px",
  borderBottom: "1px solid rgba(0, 0, 0, 0.42)",
  marginRight: "13px",
  fontSize: "16px",
  color: "rgb(0, 0, 0, 0.87)",
  outline: "none",
}));

//TODO: Add width conditionally
export const DepartmentSelectWrapper = styled(FormControl)`
  width: 100%;
`;

export const DepartmentLabel = styled(InputLabel)``;

export const SwitchWrapper = styled(Box)`
  display: flex;
  align-items: center;
  height: 56px;
  border: 1px solid ${theme.palette.grey[200]};
  border-radius: 4px;
  padding: 8px !important;
  margin-top: 10px;
`;

export const VersionNumber = styled(Typography)`
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  margin-top: 12px;
`;

export const ModalHeader = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ModalHeading = styled(Typography)`
  font-weight: bold;
  font-size: medium;
`;
